<template>
    <div>
        <!--pradeep start -->
        <v-offline
                online-class="online"
                offline-class="offline"
                @detected-condition="amIOnline"
        >
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <div id="MVD" v-if="projectOverview">
            <div class="row setMarginTop">
                <template v-if="$store.getters.getCurrentSelectedProject.banner_message!=null">
                    <div v-if="$store.getters.getCurrentSelectedProject.banner_message!=''" class="col-sm-12">
                        <div class="card setShadow">
                            <div class="card-body" style="padding: 10px;">
                                <p style="margin-top: 15px; font-size: 15px; font-weight: bold;">{{
                                        $store.getters.getCurrentSelectedProject.banner_message
                                    }}</p>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
                    <div class="card setShadow">
                        <div class="card-body" style="padding: 10px;">
                            <MapBase
                                :enableCluster="true"
                                :enableKml="true"
                                :kmlFiles="projectOverview.areas_kml"
                                :pins="mvmarkers"
                                :center="center"
                                :zoom="7"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
                    <div class="card setShadow">
                        <div class="card-body" style="padding: 10px;">
                            <span>Location</span>
                            <h5>{{projectOverview.project_location}}</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row setMarginTop">
                <div class="col-xs-6 col-sm-6 col-md-3">
                    <div class="card setShadow">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="numbers">
                                            <p>Project Owner</p>
                                            <a :href="'mailto:' + projectOverview.ownerEmail + '?subject=' + projectOverview.name "> {{ projectOverview.project_owner }} </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-3">
                    <div class="card setShadow">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="numbers">
                                            <p>Total Treated</p>
                                            {{
                                                projectOverview.total_animals_treated
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xs-6 col-sm-6 col-md-3">
                    <div class="card setShadow">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="numbers">
                                            <p>Out of Area</p>
                                            <!-- 999 -->
                                            {{ projectOverview.total_out_of_area }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row setMarginTop">
                <div class="col-sm-6 col-xs-6 col-md-3">
                    <div class="card setShadow">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="numbers">
                                            <p>Vaccination Areas</p>
                                            <!-- 999 -->
                                            {{ projectOverview.total_areas }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-6 col-md-3">
                    <div class="card setShadow">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="numbers">
                                            <p>
                                                Vacc. Areas Assigned
                                            </p>
                                            <!-- 899 -->
                                            {{ projectOverview.assigned_areas }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-3">
                    <div class="card setShadow">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="numbers">
                                            <p>Avg Treated/Day
                                                <el-tooltip content="Days with no activity are not considered in this calculation" placement="top">
                                                    <i class="el-icon-info"></i>
                                                </el-tooltip>
                                            </p>
                                            <!-- 999 -->
                                            {{ projectOverview.avg_animals_vaccinated_per_day }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-6 col-md-3">
                    <div class="card setShadow">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="numbers">
                                            <p>Avg Vacc. Time</p>
                                            {{
                                                projectOverview.avg_time_taken_for_vaccination
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row setMarginTop">
                <div class="col-sm-6 col-xs-6 col-md-3">
                    <div class="card setShadow">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="numbers">
                                            <p>Areas Surveyed</p>
                                            <!-- 799 -->
                                            {{ projectOverview.areas_surveyed }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-6 col-md-3">
                    <div class="card setShadow">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="numbers">
                                            <p>Areas Surveyed & Target Met</p>
                                            {{
                                                projectOverview.areas_completed
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-6 col-md-3">
                    <div class="card setShadow">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="numbers">
                                            <p>Areas Not Surveyed</p>
                                            <!-- 99 -->
                                            {{
                                                projectOverview.areas_not_surveyed
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-3">
                    <div class="card setShadow">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="numbers">
                                            <p>
                                                Vacc. Rate Based on Surveys
                                            </p>
                                            {{ projectOverview.avg_area_covered }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row setMarginTop set_res_margin_top">
                <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
                    <div class="row setTitleDiv">
                        <p></p>
                    </div>
                    <!-- Pradeep Start -->
                    <div class="setMarginTop">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-6" v-if="PieChartOptions.series[0].data.length>0">
                                <div class="card setShadow">
                                    <div
                                            class="card-body"
                                            style="height: 435px;">
                                        <highcharts
                                                :options="PieChartOptions"
                                        ></highcharts>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-6" v-if="LineChartOptions.series.length>0">
                                <div class="card setShadow">
                                    <div class="card-body" style="height: 480px;">
                                        <div class="chart-filter-row">
                                            <el-date-picker
                                                v-model="monthlyTreatedDateRange"
                                                type="daterange"
                                                range-separator="-"
                                                start-placeholder="Start date"
                                                end-placeholder="End date"
                                                format="dd-MM-yyyy"
                                                value-format="yyyy-MM-dd"
                                                size="small"
                                                @change="onMonthlyTreatedDateChange"
                                                :clearable="true"
                                                :picker-options="datePickerOptions"
                                            ></el-date-picker>
                                        </div>
                                        <div class="chart-container" v-loading="lineChartLoading">
                                            <highcharts
                                                    :options="LineChartOptions"
                                            ></highcharts>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-6"
                                 v-if="StackedColumnChartOptions.series.length>0 && hasStackedChartData">
                                <div class="card setShadow">
                                    <div class="card-body" style="height: 480px;">
                                        <div class="chart-filter-row">
                                            <el-date-picker
                                                v-model="genderAgeDateRange"
                                                type="daterange"
                                                range-separator="-"
                                                start-placeholder="Start date"
                                                end-placeholder="End date"
                                                format="dd-MM-yyyy"
                                                value-format="yyyy-MM-dd"
                                                size="small"
                                                @change="onGenderAgeDateChange"
                                                :clearable="true"
                                                :picker-options="datePickerOptions"
                                            ></el-date-picker>
                                        </div>
                                        <div class="chart-container" v-loading="stackedChartLoading">
                                            <highcharts
                                                    :options="StackedColumnChartOptions"
                                            ></highcharts>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Pradeep End -->
                </div>
            </div>
            <div class="row setMarginTop">
                <div class="col-md-12 col-xl-12 col-sm-12 col-xs-12 set_res_margin_top">
                    <div class="row setTitleDiv">
                        <p>Field User - Stats</p>
                    </div>
                    <div class="row setMarginTop">
                        <div class="col-sm-6 col-xs-6 col-md-3 col-xl-3">
                            <div class="card setShadow">
                                <div class="card-body">
                                    <div>
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="numbers">
                                                    <p>Vaccinators</p>
                                                    <!-- 99 -->
                                                    {{ projectOverview.vaccinators }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-xs-6 col-md-3 col-xl-3">
                            <div class="card setShadow">
                                <div class="card-body">
                                    <div>
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="numbers">
                                                    <p>Surveyors</p>
                                                    <!-- 99 -->
                                                    {{ projectOverview.surveyors }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-xs-6 col-md-3 col-xl-3">
                            <div class="card setShadow">
                                <div class="card-body">
                                    <div>
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="numbers">
                                                    <p>
                                                        Avg Animals Treated by User/Day
                                                    </p>
                                                    {{ projectOverview.avg_animals_vaccinated_per_user_day }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-xs-6 col-md-3 col-xl-3">
                            <div class="card setShadow">
                                <div class="card-body">
                                    <div>
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="numbers">
                                                    <p>Non-Active Field Users</p>
                                                    <!-- 0 -->
                                                    {{ projectOverview.non_active_field_users }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="row setTitleDiv">
                        <p>Field User Activity</p>
                    </div>
                </div>
                <div class="col-sm-12">
                    <dash-tables :columns="fieldUserActivityColumns" :users="projectOverview.active_users_last_ten_days"></dash-tables>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
import mixin from "../../mixins/GlobalMixin";
import FgInput from "./UIComponents/Inputs/formGroupInput";
import Mvdproject from "./Tables/MvdprojectDetails.vue";
import DashboardTables from "./Tables/DashboardTables.vue";
import DashboardCharts from "./Dashboardchart.vue";
import DashboardpieCharts from "./DashboardpieCharts.vue";
import Mvd from "./Mvd.vue";

import {Autocomplete, Tooltip, DatePicker} from "element-ui";

import {mapGetters} from "vuex";

import Swal from "sweetalert2"
import VOffline from "v-offline";

// Highcharts Start
import {Chart} from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import exportingInitData from "highcharts/modules/export-data";
import MapBase from "../map/MapBase.vue";

exportingInit(Highcharts);
exportingInitData(Highcharts);
// Highcharts End

export default {
    components: {
        FgInput,
        [Autocomplete.name]: Autocomplete,
        [Tooltip.name]: Tooltip,
        [DatePicker.name]: DatePicker,
        "mvd-project": Mvdproject,
        "dash-tables": DashboardTables,
        charts: DashboardCharts,
        "pie-charts": DashboardpieCharts,
        "line-mvd": Mvd,
        VOffline,
        highcharts: Chart,
        MapBase
    },
    props: {
        projectId: {
            type: Number
        },
        organisation: String
    },
    mixins: [mixin],
    data()
    {
        return {
            project: {},
            errorMsg: null,
            center: {lat: 33.8291523, lng: -116.8004315},
            mvmarkers: [],
            PieChartOptions: {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: "pie",
                    style: {
                        fontFamily:
                            "Montserrat,Helvetica Neue,Arial,sans-serif",
                        fontSize: "10px"
                    }
                },
                title: {
                    text: "Animals Treated (Species)",
                    align: "left",
                    style: {
                        color: "#252422",
                        fontSize: "18px",
                        fontWeight: "400",
                        fontFamily: "Montserrat,Helvetica Neue,Arial,sans-serif"
                    }
                },
                tooltip: {
                    pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: "pointer",
                        dataLabels: {
                            enabled: true,
                            format:
                                "<b>{point.name}</b>: {point.y}",
                            style: {
                                fontWeight: "400"
                            }
                        }
                    }
                },
                series: [
                    {
                        name: "Animal",
                        colorByPoint: true,
                        data: [

                        ]
                    },
                ]
            },
            StackedColumnChartOptions: {
                chart: {
                    type: 'column',
                    style: {
                        fontFamily: "Montserrat,Helvetica Neue,Arial,sans-serif"
                    }
                },
                title: {
                    text: 'Vaccinations by Gender/Age',
                    align: "left",
                    style: {
                        color: "#252422",
                        fontSize: "18px",
                        fontWeight: "400",
                        fontFamily: "Montserrat,Helvetica Neue,Arial,sans-serif"
                    }
                },
                xAxis: {
                    categories: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    labels: {
                        //rotation: -90,
                        formatter: function () {
                            const date = new Date();
                            const month = date.toLocaleString('default', {month: 'short'});
                            if (month == this.value) {
                                return '<span style="fill: red; font-size: 13px;">' + this.value + '</span>';
                            } else {
                                return this.value;
                            }
                        }
                    },
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: ''
                    }
                },
                legend: {
                    align: 'center',
                    verticalAlign: 'bottom',
                    floating: false,
                    backgroundColor:
                        Highcharts.defaultOptions.legend.backgroundColor || 'white',
                    shadow: false
                },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },
                series: [],
            },
            LineChartOptions: {
                chart: {
                    type: "column",
                    style: {
                        fontFamily: "Montserrat,Helvetica Neue,Arial,sans-serif"
                    }
                },
                title: {
                    text: "Vaccinations by Month",
                    align: "left",
                    style: {
                        color: "#252422",
                        fontSize: "18px",
                        fontWeight: "400",
                        fontFamily: "Montserrat,Helvetica Neue,Arial,sans-serif"
                    }
                },
                subtitle: {
                    text: ""
                },
                xAxis: {
                    categories: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    labels: {
                        //rotation: -90,
                        formatter: function () {
                            const date = new Date();
                            const month = date.toLocaleString('default', {month: 'short'});
                            if (month == this.value) {
                                return '<span style="fill: red; font-size: 13px;">' + this.value + '</span>';
                            } else {
                                return this.value;
                            }
                        }
                    },
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: ""
                    }
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },
                series: []
            },
            projectOverview: {
                name: null,
                ownerEmail: null
            },
            fieldUserActivityColumns: [
                {
                    prop: 'name',
                    label: 'Field User',
                    minWidth: 100,
                },
                {
                    prop: 'area',
                    label: 'Areas',
                    minWidth: 100,
                },
                {
                    prop: 'status',
                    label: 'Area Status',
                    minWidth: 100,
                },
                {
                    prop: 'date',
                    label: 'Date',
                    minWidth: 100,
                },
            ],
            monthlyTreatedDateRange: null,
            genderAgeDateRange: null,
            lineChartLoading: false,
            stackedChartLoading: false,
            datePickerOptions: {
                shortcuts: [
                    {
                        text: 'Last 30 days',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'Last 3 months',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 3);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'Last 6 months',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 6);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'This year',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0, 1);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'Last year',
                        onClick(picker) {
                            const year = new Date().getFullYear() - 1;
                            const start = new Date(year, 0, 1);
                            const end = new Date(year, 11, 31);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    methods: {
        plotVaccinationPoints()
        {
            const vm = this;
            const pinPoints = vm.projectOverview.vaccination_pins;

            for (let i = 0; i < pinPoints.length; i++) {
                let latLng = pinPoints[i].split(",");
                latLng = {lat: +latLng[0], lng: +latLng[1]};
                vm.mvmarkers.push(latLng);
            }
        },
        setPieChart(data)
        {
            const pieData = [...data];
            // pieData.forEach(el => {
            //     el.color = '#' + el.color;
            // })
            this.PieChartOptions.series[0].data = pieData;
        },
        setLineChart(data)
        {
            // pieData.forEach(el => {
            //     el.color = '#' + el.color;
            // })
            this.LineChartOptions.series = [...data];
        },
        setStackedColumnChart(data)
        {
            this.StackedColumnChartOptions.series = [...data];
        },
        async onMonthlyTreatedDateChange(dateRange)
        {
            await this.fetchFilteredChartData(dateRange, 'monthly_treated');
        },
        async onGenderAgeDateChange(dateRange)
        {
            await this.fetchFilteredChartData(dateRange, 'gender_age');
        },
        async fetchFilteredChartData(dateRange, chartType)
        {
            const vm = this;
            
            if (chartType === 'monthly_treated') {
                vm.lineChartLoading = true;
            } else if (chartType === 'gender_age') {
                vm.stackedChartLoading = true;
            }
            
            try {
                const params = {};
                if (dateRange && dateRange.length === 2) {
                    params.start_date = dateRange[0];
                    params.end_date = dateRange[1];
                }
                
                const response = await axios.post(
                    "/stats/mv/project/monthly-charts/" + vm.projectId,
                    params
                );
                
                const data = response.data.response.data;
                const monthLabels = data.month_labels || [];
                
                if (chartType === 'monthly_treated' || chartType === 'both') {
                    vm.setLineChart(data.monthly_treated);
                    vm.updateChartCategories('line', monthLabels);
                }
                
                if (chartType === 'gender_age' || chartType === 'both') {
                    vm.setStackedColumnChart(data.monthly_treated_by_gender_and_age);
                    vm.updateChartCategories('stacked', monthLabels);
                }
            } catch (error) {
                console.error('Error fetching filtered chart data:', error);
            } finally {
                if (chartType === 'monthly_treated') {
                    vm.lineChartLoading = false;
                } else if (chartType === 'gender_age') {
                    vm.stackedChartLoading = false;
                }
            }
        },
        updateChartCategories(chartType, labels)
        {
            if (labels && labels.length > 0) {
                if (chartType === 'line') {
                    this.LineChartOptions.xAxis.categories = labels;
                } else if (chartType === 'stacked') {
                    this.StackedColumnChartOptions.xAxis.categories = labels;
                }
            }
        }
    },
    computed: {
        //...mapGetters("user", ["userRoles"]),
        ...mapGetters("user", ["userRoles"]),
        apiError: function () {
            return this.errorMsg !== null;
        },
        projectCategories: function () {
            if (this.project.category != null) {
                return this.project.category.split(",");
            } else {
                return [];
            }
        },
        hasStackedChartData: function () {
            if (!this.StackedColumnChartOptions.series || this.StackedColumnChartOptions.series.length === 0) {
                return false;
            }
            return this.StackedColumnChartOptions.series.some(series => series.data && series.data.length > 0);
        }
    },
    async mounted()
    {
        // this.geolocate();
        let vm = this;
        vm.$store.dispatch("setScreenName", "Overview");
        let response;
        try {
            response = await axios.get(
                "/stats/mv/project/dashboard/" + vm.projectId
            );

            const {owner, name} = vm.$store.getters.getCurrentSelectedProject;
            vm.projectOverview = Object.assign(response.data.response.data, {
                name,
                ownerEmail: owner.email
            });
            // vm.projectOverview = Object.assign(vm.projectOverview, response.data.response.data);

            vm.setPieChart(vm.projectOverview.charting_details.animals_treated)
            vm.setLineChart(vm.projectOverview.charting_details.monthly_treated)
            vm.setStackedColumnChart(vm.projectOverview.charting_details.monthly_treated_by_gender_and_age)


            vm.$store.dispatch("user/getUserRoles");

            const latLngArr = vm.projectOverview.project_location_lat_lng.split(",");
            vm.center = {lat: +latLngArr[0], lng: +latLngArr[1]};
            vm.plotVaccinationPoints();
        } catch (error) {
        }
        
        try {
            setTimeout(function () {
                document
                    .querySelectorAll(".highcharts-credits")
                    .forEach(function (el) {
                        el.innerHTML = "";
                    });
                document.querySelectorAll("tspan").forEach(function (element) {
                    element.style.fontWeight = "400";
                });
            }, 2000);
        } catch (e) {
        }
    }
};
</script>
<style scoped>
td,
th {
    padding-right: 10px;
}

.card .numbers p {
    font-size: 14px !important;
    color: #9a9a9a !important;
}

.card .number {
    /* font-size: 14px !important; */
    color: #9a9a9a !important;
    font-size: 1.5em;
    text-align: right;
}

.card .number p {
    margin: 0;
    font-size: 13px;
}

.setShadow {
    box-shadow: 0 6px 10px 0px rgba(0, 0, 0, 0.15) !important;
}

.card .card-body {
    text-align: center;
}

.containBytitile h4 {
    font-size: 1.2em;
    line-height: 1.45em;
}

.projectdetail-desktop {
    margin-left: 20px !important;
    cursor: pointer;
}

.Set-floatright {
    float: right;
}

.setTitleDiv p {
    font-size: 15px;
    font-weight: 600;
    color: black;
}

.set_mvd_res_chart {
    height: 338px;
}

.img_marker_popup {
    /* max-width: 100% !important; */
    height: 70px;
    width: 70px;
}

.info_window_row {
    margin-right: -5px !important;
    margin-left: -5px !important;
}

@media only screen and (max-width: 640px) {
    .projectdetail-desktop {
        float: left;
        margin-top: -36px;
        margin-left: 247px;
        cursor: pointer;
    }
}

@media only screen and (max-device-width: 768px) {
    .set_mvd_res_chart {
        height: 50%;
    }
}

@media (min-width: 780px) {
    .mvd_details_class {
        height: 407px;
    }

    .set_res_activity_status {
        height: 600px;
    }
}

.set_b_font {
    font-size: 16px !important;
    color: #9a9a9a !important;
}

.set_b_font_card {
    font-size: 17px !important;
    color: #9a9a9a !important;
}

.text_left {
    text-align: left !important;
}

.set_numbers_div {
    padding: 5px 15px 10px;
    text-align: center;
}

.set_card_Operated {
    height: 124px;
}

.set_card_deaths {
    height: 150px;
}

@media (min-width: 780px) {
    .set_card_height_avg {
        height: 142px;
    }
}

.set_card_caught {
    margin-bottom: -27px;
}

.owner-name {
    font-size: 14px !important;
}

@media (max-width: 1025px) {
  .card .numbers {
    font-size: 1em !important;
  }

  .card .numbers p {
    font-size: 12px !important;
  }
}

@media (min-width: 1025px) and (max-width: 1440px) {
  .card .numbers {
    font-size: 1.5em !important;
  }

  .card .numbers p {
    font-size: 13px !important;
  }
}

.chart-filter-row {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
    padding: 0 10px;
}

.chart-filter-row .el-date-editor {
    width: 280px !important;
}

.chart-container {
    height: 400px;
    position: relative;
}

</style>
